import styled from 'styled-components';
import BaseIcon from '../../../Icon/Icon';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 45px 20px;
  text-align: center;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.brand.primary.base};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 56px 60px;
  }
`;

const Container = styled.div`
  max-width: 220px;
`;

const Icon = styled(BaseIcon)`
  path {
    stroke-width: 1;
  }
`;

export { Container, Wrapper, Icon };
